/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { FronteggRoleMigrationResponseDto } from '../models/FronteggRoleMigrationResponseDto';

export class MigrationsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns FronteggRoleMigrationResponseDto
   * @throws ApiError
   */
  public migrationControllerMigrateFronteggRoles(): CancelablePromise<FronteggRoleMigrationResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/migrations/role',
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public migrationControllerSyncFronteggRoleMappings(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/migrations/frontegg-role-mappings',
    });
  }
}
